<template>
    <rkm-wizard
        ref="Wizard"
        :disabled-next-button="disabledNextButton"
        @finish="$emit('finish')"
    >
        <rkm-wizard-tab
            v-if="showBusca"
            title="Busca"
            icon="fas fa-search"
            :before-change="validateBusca"
        >
            <TabBusca
                :additionals="additionals"
                :form="form"
                :on-continue="() => $refs.Wizard.nextTab()"
                @form-change="$emit('form-change', $event)"
                @searching="disabledNextButton = $event"
                @select-cidadao="handleCidadaoSelected"
                ref="TabBusca"
            />
        </rkm-wizard-tab>

        <rkm-wizard-tab
            title="Identificação"
            icon="fas fa-id-card-alt"
            :before-change="() => $refs.TabIdentificacao.validate()"
        >
            <TabIdentificacao
                :additionals="additionals"
                :form="form"
                :model="model"
                ref="TabIdentificacao"
            />
        </rkm-wizard-tab>

        <rkm-wizard-tab
            title="Documentações"
            icon="fas fa-file-contract"
            :before-change="() => $refs.TabDocumentos.validate()"
        >
            <TabDocumentos
                ref="TabDocumentos"
                :form="form"
                :model="model"
            />
        </rkm-wizard-tab>

        <rkm-wizard-tab
            title="Endereço"
            icon="fas fa-map-marker-alt"
            :before-change="() => $refs.TabEndereco.validate()"
        >
            <TabEndereco
                ref="TabEndereco"
                :form="form"
                :model="model"
            />
        </rkm-wizard-tab>

        <rkm-wizard-tab
            title="Unidade/Equipe de referência"
            icon="fas fa-hospital-user"
            :before-change="() => $refs.TabIdentificacaoSaude.validate()"
        >
            <TabIdentificacaoSaude
                ref="TabIdentificacaoSaude"
                :form="form"
                :model="model"
            />
        </rkm-wizard-tab>

        <rkm-wizard-tab
            title="Questionário de saúde"
            icon="fas fa-heartbeat"
            :before-change="() => $refs.TabQuestionarioSaude.validate()"
        >
            <TabQuestionarioSaude
                ref="TabQuestionarioSaude"
                :form="form"
                :model="model"
            />
        </rkm-wizard-tab>

        <rkm-wizard-tab
            title="Informações sociais"
            icon="fas fa-user"
            :before-change="() => $refs.TabInformacoesSociais.validate()"
        >
            <TabInformacoesSociais
                ref="TabInformacoesSociais"
                :form="form"
                :model="model"
            />
        </rkm-wizard-tab>

        <rkm-wizard-tab
            title="Informações residenciais"
            icon="fas fa-home"
            :before-change="() => $refs.TabInformacoesResidenciais.validate()"
        >
            <TabInformacoesResidenciais
                ref="TabInformacoesResidenciais"
                :form="form"
                :model="model"
            />
        </rkm-wizard-tab>

        <rkm-wizard-tab
            title="Composição familiar"
            icon="fas fa-users"
            :before-change="() => $refs.TabComposicaoFamiliar.validate()"
        >
            <TabComposicaoFamiliar
                ref="TabComposicaoFamiliar"
                :form="form"
                :model="model"
            />
        </rkm-wizard-tab>
    </rkm-wizard>
</template>

<script>
// Components.
import TabBusca from './tabs/Busca'
import TabIdentificacao from './tabs/Identificacao'
import TabIdentificacaoSaude from './tabs/IdentificacaoSaude'
import TabEndereco from './tabs/Endereco'
import TabDocumentos from './tabs/Documentos'
import TabQuestionarioSaude from './tabs/QuestionarioSaude'
import TabInformacoesSociais from './tabs/InformacoesSociais'
import TabInformacoesResidenciais from './tabs/InformacoesResidenciais'
import TabComposicaoFamiliar from './tabs/ComposicaoFamiliar'

export default {
    components: {
        TabBusca,
        TabIdentificacao,
        TabIdentificacaoSaude,
        TabEndereco,
        TabDocumentos,
        TabQuestionarioSaude,
        TabInformacoesSociais,
        TabInformacoesResidenciais,
        TabComposicaoFamiliar
    },
    props: {
        additionals: { type: Object, required: true, default: () => ({}) },
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    data: () => ({
        showBusca: true,
        disabledNextButton: false,
        selectedCidadao: null,
    }),
    methods: {
        validate() {

            return this.$refs.TabQuestionarioSaude.validate()
        },
        async validateBusca() {

            const valid = await this.$refs.TabBusca.validate()

            if (valid) {

                this.$emit('exit-busca', this.selectedCidadao)

                this.showBusca = false
            }

            return valid
        },
        handleCidadaoSelected(cidadao) {

            this.selectedCidadao = cidadao

            this.$refs.Wizard.nextTab()
        },
    },
}
</script>